'use client';

import dynamic from 'next/dynamic';

/**
 * `ConversionPageAdConversions`, code-split: `RenderPage` renders every page
 * of every tenant, and only a Conversion Page with Ad Conversions needs this.
 * `ssr: false` because it renders nothing and only reports from the browser.
 */
export const ConversionPageAdConversions = dynamic(() => import('./conversion-page-ad-conversions'), {
  ssr: false,
});
